export const CLOSING_CLASSNAME = 'closing';
